export default {
  h1: {
    fontWeight: 500,
    fontSize: 35,
    fontFamily: "Helvetica",
  },
  h2: {
    fontWeight: 500,
    fontSize: 30,
  },
  h3: {
    fontWeight: 500,
    fontSize: 25,
    fontFamily: "Helvetica",
  },
  h4: {
    fontWeight: 500,
    fontSize: 20,
    fontFamily: "Helvetica",
  },
  h5: {
    fontWeight: 500,
    fontSize: 18,
    fontFamily: "Helvetica",
  },
  h6: {
    fontWeight: 500,
    fontSize: 16,
    fontFamily: "Helvetica",
  },
  overline: {
    fontWeight: 500,
    fontFamily: "Helvetica",
  },
  button: {
    textTransform: "capitalize",
    borderRadius: 27,
    fontFamily: "Helvetica",
  },
  body1: {
    fontSize: 12,
    fontFamily: "Helvetica",
  },
  body2: {
    fontSize: 14,
    fontFamily: "Helvetica",
  },
};
